module.exports = __webpack_public_path__ + "media/images/ns-splashscreen-2021-50f8dffe4f20d463c72ee3f219d94d2f.svg";